import { sidebarName_ch } from "./sidebarName";
import { about } from "./aboutInfo";

export default {
  sidebarName: sidebarName_ch,
  about: about,
  chatArea: '聊天区',
  send: '发送',
  delete: '删除',
  audience: '观展',
  stopTalk: '终止洽谈',
  endTalk: '结束洽谈',
  beginTalk: '开始洽谈',
  endForum: '结束',
  beginForum: '开始',
  payError: "支付失败",
  permissionDenied: '无法获取麦克风、摄像头。请打开麦克风、摄像头的权限',
  ask: '提问',
  agree: '同意',
  talkEnded: '展商已经结束洽谈',
  forumEnded: '论坛已经结束',
  HTC: "系统说明",
  endTalkByAnchor: '展商结束了洽谈',
  addToBlacklist: '您被请出了洽谈室',
  cancelAsk: '取消提问',
  askReject: '您的请求发言被拒绝',
  askAgree: '您的提问被同意',
  endAsk: '结束提问',
  addBlacklist: '加入黑名单',
  whiteboard: '白板',
  uploadFile: '上传文件',
  file: '文件',
  fileManage: '文件管理',
  appendixManage: '附件管理',
  video: '视频',
  inputPlease: '请输入聊天内容..',
  title: '标题中文',
  exhibition: "展会",
  userInfo: "个人中心",
  login: "登录",
  search: "搜索",
  details: "详情",
  packUp: "收起",
  loadingLogin: "登陆中...",
  findPwd: "找回密码",
  register: "注册",
  english: "English",
  explain: "系统使用说明",
  exhibitionState: "展会状态",
  notEnter: "暂不进入",
  state: "状态",


  state0: "全部",
  state1: "未开展",
  state2: "进行中",
  state3: "已结束",


  exState: "招商中",
  exState1: "预约中",
  exState2: "进行中",
  exState3: "已结束",


  exhibitionSelect: "请选择子账号",
  exhibitionName: "请输入展会名称",
  participation: "参展报名",
  exhibitionVisit: "观展报名",
  joinVenue: "进入会场",
  exhibitionTime: "展会时间",
  exhibitionIntroduce: "展会简介",
  clues: "距离开幕还有",
  leave: "离开",
  day: "天",
  talkBtn: "我要洽谈",
  loginPrompt: "请输入手机号",
  password: "密码",
  accountLogin: "账号登录",
  ticketsLogin: "票号登录",
  banks: "票号",
  username: "姓名",
  phone: "手机号",
  ticketNumber: "请输入票号",
  inputName: "请输入用户姓名",
  oneToOne: "一对一",
  to: "至",
  forum: "论坛",
  inputPhone: "请输入手机号",
  regInputPhone: "请输入手机号",
  inputCode: "请输入验证码",
  setPwd: "设置密码",
  reqPwd: "确定密码",
  verificationCode: "验证码",
  overtime: "登陆超时，请重新登录",
  sendVerificationCode: "获取验证码",
  toResend: "重新发送",
  userInfoRules: "信息不能为空",
  passwordRules: "密码不能为空",
  ticketRules: "票号不能为空",
  usernameRules: "姓名不能为空",
  phoneRules: "手机号不能为空",
  phoneLoginRules: "手机号不能为空",
  codeRules: "验证码不能为空",
  phoneCorrectlyRules: "请输入正确的手机号",
  passwordCorrectlyRules: "密码应为6-20位英文字母、数字或者符号（除空格），且字母、数字和标点符号至少包含两种",
  emailRules: "邮箱不能为空",
  emailCorrectlyRules: "请输入正确的邮箱",
  protocol: "我已阅读",
  deal: "用户协议",
  nickName: "姓名",
  companyName: "公司名称",
  home: "所在地",
  userPost: "职务",
  email: "邮箱",
  contact: "联系方式",
  contactRules: "联系方式不能为空",
  userRules: "姓名不能为空",
  userCorrectlyRules: "姓名应为6-20字符和数",
  companyNameRules: "公司名称不能为空，且最多100个字符",
  homeRules: "所在地不能为空并且最多为100个字符",
  trueNameRules: "姓名不能为空，且最多5个字符",
  jobRules: "职务不能为空，且最多60个字符",
  logout: "退出登录",
  marked: "是否退出当前用户?",
  hint: "提示",
  liveClass: "直播间分类",
  exit: "退出",
  cancel: "取消",
  exitSuccess: "退出成功",
  hitDown: "点击'下载'按钮，下载最高版本chrome浏览器",
  leaveDown: "请前往chrome浏览器进入直播间",
  hold: "直播间功能不支持本浏览器运行,",
  COPC: "客服服务中心",
  aboutUs: "关于我们",
  blueBusiness: "蓝网商机",
  forwarderConference: "货代联合大会",
  GlobalShippingSummit: "全球海运峰会",
  InternationalFreightFair: "国际货运交易会",
  setToHomePage: "设为首页",
  shippingNetwork: "国际海运网",
  platform: "接待参展、观展、广告、调试等咨询",
  aboutExh: "关于云展",
  exhTel: "云展客服",
  allRightsReserved: "版权所有",
  customerPhone: "客服电话",
  license: "许可证号",
  offlineEvent: "线下展会",
  internetRecord: "网站备案号",
  exhibitionRecord: "观展记录",
  applet: "小程序",
  pleaseEnterPwd: "请输入密码",
  pleaseAgainEnterPwd: "请在此输入密码",
  save: "保存",
  edit: "修改",
  editSuccess: "修改成功",
  enter: "进入",
  editExh: "我要布展",
  enterExh: "进入直播",
  ticText: "邀请人员进入可以参与直播",
  buy: "购买",
  //个人中心模块
  personal: '个人信息',
  ParticipationRecord: '参展记录',
  myTicket: '我的门票',
  subaccountManagement: '子账号管理',
  studioManagement: '直播间管理',
  changePassword: '修改密码',
  createBBS: '创建论坛',
  visitorTickets: '观展门票',
  ticketsExhibition: '参展席位',
  exhSeat: "展会席位",
  error: "暂无数据",
  oneTone: '一对一',
  bbs: '论坛',
  accountId: '账号ID',
  mobilePhone: '手机号',
  name: '姓名',
  classification: '分类',
  //我的门票/观展门票
  fairName: '展会名称',
  fairTime: '展会时间',
  price: '价格',
  buyTime: '购买时间',
  operation: '操作',
  //我的门票/参展门票
  ticketsTypes: '席位类型',
  role: '角色',
  attributable: '归属者',
  //直播间管理
  bbsName: '论坛名称',
  studioFairName: '直播间名称/展会名称',
  //观展记录
  studioName: '直播间名称',
  broadcastType: '直播间类型',
  seeContact: "查看联系方式",
  helpfulHints: "友情提示!",
  notLogin: "你还未登录，请先登录，若无账号请先注册",
  notTicket: "你还未购票，请先购票",
  paymentMethod: "请选择付款方式",
  buyWatchTickets: "购买观展票",
  buyExhibitionTickets: "购买展位",
  site: "展位",
  site1: "张",
  onlineBuy: "线上购买",
  offlineBuy: "线下购买",
  total: "合计",
  weChat: "微信",
  payTreasure: "支付宝",
  CNY: "元",
  rates: "门票价格",
  buyTicketNumbers: "购买张数",
  buyTicketNumber: "展位数",
  PCS: "个",
  peopleSeat: "人席位展",
  oneSeat: "1人席位展",
  twoSeat: "2人席位展",
  threeSeat: "3人席位展",
  haveRead: "我已阅读",
  ticketAgreement: "购票协议",
  scanQR: "扫码了解更多内容",
  local: "地点",
  internationalization: "第九届中国国际货代年会暨国际货运对接展会",
  wxPay: "微信扫码支付",
  startTime: "2020年11月2-3日",
  sponsor: "主办单位",
  localPlace: "大连国际会议中心，大连富力希尔顿酒店",
  payMoney: "微信支付",
  scan: "请使用微信扫一扫",
  scanPay: "扫描二维码支付",
  backPay: "选择其他支付方式",
  guest: "嘉",
  client: "宾",
  compere: "主持人",
  sum: "共",
  time: "时间",
  watchReplay: "观看回放",
  watch: "查看",
  playback: "回放",
  playbackList: "回放列表",
  talkCompany: "观众名单",
  forumCompany: "洽谈公司列表",
  loginSuccess: "登陆成功",
  registerSuccess: "注册成功",
  bankCard: "开户行",
  accountName: "户名",
  company: "大连万发联合航贸科技有限公司",
  copyTic: "复制票号",
  cardNumber: "中信银行大连中山支行",
  accountCompany: "公司账户",
  companyAccount: "7211410182600144711",
  buyOffInfo: "线下购买请联系 04198258323 咨询详情",


  childAccount: '选择子账号',
  confirm: '确认',
  findInput: "手机号",
  telNumber: "手机",
  doYouConfirm: '确认回收',
  tickets: '的票吗？',
  subAccount: '的账号吗？',
  editeStudio: '我要布展',
  suggestSize: '建议尺寸',
  card: "货代小名片",
  makeCard: "13000位货代同行",
  extend: "等待交互",
  exhService: "展会客服服务中心",
  serveTel: "服务热线",
  contactPeople: "联系人",
  exhAttract: "展会招商",
  advertisingAttract: "广告招商",
  overseasInvestment: "海外招商",
  cloud: "在线订舱交易",
  FAE: "技术支持工程师",
  vip: "WIFFA会员合作",
  directories: "全国98个城市",
  know: "千家信用会员",
  business: "展会服务中心",
  click: '点击',
  uploadLogo: '上传logo',
  zhang: "张",
  startDate: '开始日期',
  endDate: '结束日期',
  date: "日期",
  segmentation: '以；分割',
  originalPassword: '原密码',
  newPassword: '新密码',
  confirmPassword: '确认密码',
  enterOriginalPassword: '请输入原密码',
  enterYourPassword: '请输入密码',
  passwordAgain: '请再次输入密码',
  samePassword: '与原密码一样!',
  twoPassinconsistent: '两次输入密码不一致!',
  notData: "暂无数据",
  seats: '席位数',
  forgotPwd: "忘记密码?",
  create: '创建',
  createSuccessful: '创建成功',
  getInMyTicket: '你可以在参展席位中查看',
  getInMyTicket1: '你可以在嘉宾席位中查看',
  see: "查看",
  giving: "分配",
  recycling: "回收",
  addChildAccount: "添加子账号",
  bbsTheme: "论坛主题",
  bbsTime: "论坛时间",
  introduction: "简介",
  companyLogo: "公司logo",
  enterUserId: "请输入被添加人帐号ID",
  addSubaccount: "添加子账号",
  subaccountText: "请输入被添加人的帐号ID,若被添加人未注册,请先让其注册。",
  add: "添加",
  areYouSuretoDelete: "确定删除",
  delSuccess: "删除成功",
  icon: "phone",
  lineWait: "排队",
  wait: "当前直播间有人洽谈,请排队等候",
  usageTitle: "本系统支持pc浏览器和微信小程序进入",
  chrome: "PC浏览器推荐使用最新版chrome浏览器",
  down: "点击下载chrome浏览器",
  appletCode: "小程序二维码",
  weChatCode: "微信扫描二维码",
  room: "直播间支持",
  exhibitor: "展商使用最新版的chrome浏览器",
  visitor: "观展使用最新版chrome浏览器和微信小程序",
  addSub: "你还没有子账号，请先添加子账号",
  accountError: "您的账号是别人的子账号不可以邀请子账号",
  hintContact: "联系方式",
  goAdd: "去添加",
  giveSuccess: "赠送成功",
  fileMaxSize: "文件大小不能超过1M",
  addSuccess: "添加成功",
  youLine: "你排队的",
  canEnter: "直播间现在可以进入",
  into: "立即进入",
  browserTip: "您当前的浏览器可能无法正常使用直播间的功能，推荐您使用最新版本的chrome浏览器进入。",
  gotIt: "知道了",
  browserLink: "下载chrome浏览器",
  userHasLeft: "用户已经离开",
  notMic: "没有麦克无法进行语音通话",
  notCamera: "没有摄像头无法进行视频通话",
  joinBlacklistTip: "确认要加入黑名单吗?",
  someoneSpeaking: "已经有人在发言",
  networkDisconnect: "网络断开连接",
  download: "下载",
  roomNumberText: "已有{0}人参与",

  peopleNumText: "已有{0}人排队",


  appointments: "查看预约",
  unfollow: "取消预约",
  makeSearch: "展会名称/论坛名称",
  ahead: "预约",
  present: "当前已经有",
  people: "人",
  alreadyHave: "已有",
  attend: "人参与",
  homePage: "首页",
  bookRecord: '预约记录',
  goto: '前往',
  page: '页',


  Domestic1:'刘宇政',
  Domestic2:'丁芳',
  Domestic3:'Lucy Bee',
  Promotion1:'张琳',
  Support1:'程培举',

  //视频列表
  congratulationsTxt:'祝贺语',
  clickPlayInstructions:'手机用户，请双击播放按钮观看',

  //顶部导航添加表演标签
   perform:'才艺展示'
}
